import { makeStyles } from '@material-ui/core/styles';

type Props = {
  isSubmitDisabled: boolean;
};

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(35, 45, 10),
  },
  wrapper: {
    marginTop: theme.spacing(74),
    display: 'flex',
    alignItems: 'center',
  },
  infoWrapper: {
    margin: theme.spacing(0, 60, 0, 0),
  },
  title: {
    font: 'normal normal 500 40px/48px Roboto',
    margin: theme.spacing(0, 0, 12.5),
  },
  subtitle: {
    font: 'normal normal normal 20px/26px Roboto',
    color: '#707070',
    margin: theme.spacing(12.5, 0, 0),
  },
  name: {
    font: 'normal normal 500 24px/33px Roboto',
    margin: theme.spacing(0, 0, 12.5),
  },
  form: {
    position: 'relative',
    overflow: 'hidden',
    maxWidth: theme.spacing(350),
    background: '#01B2AE 0% 0% no-repeat padding-box',
    padding: theme.spacing(30, 35),
    borderRadius: '15px',
    textAlign: 'center',
  },
  topLeftSquares: {
    position: 'absolute',
    top: 0,
    left: '-10px',
  },
  topRightSquares: {
    position: 'absolute',
    top: '-50px',
    right: '66px',
  },
  bottomSquares: {
    position: 'absolute',
    bottom: '-60px',
    left: '36%',
  },
  inputWrapper: {
    height: theme.spacing(23.5),
    width: '100%',
    display: 'flex',
  },
  textField: {
    '& > div': {
      height: '100%',
    },
  },
  input: {
    color: '#2D2D2D',
    background: '#fff',
    borderRadius: '10px 0px 0px 10px',
    height: '100%',
    width: theme.spacing(242),
    padding: 0,
    paddingLeft: theme.spacing(10),
  },
  label: {
    font: 'normal normal 500 13px/18px Roboto',
    display: 'flex',
    color: '#FFFFFF',
    padding: '0 0 5px 10px',
  },
  disabled: {
    borderRadius: '10px',
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  browseFileBtn: {
    background: '#233B58 0% 0% no-repeat padding-box',
    font: 'normal normal normal 14px/16px Helvetica Neue',
    textTransform: 'capitalize',
    borderRadius: '0 10px 10px 0',
    boxShadow: 'unset',
    width: theme.spacing(57),
    padding: theme.spacing(3, 7),

    '&:focus': {
      background: '#233B58 0% 0% no-repeat padding-box',
    },
  },
  submitBtn: {
    height: theme.spacing(30),
    cursor: 'pointer',
    width: '100%',
    background: ({ isSubmitDisabled }: Props) =>
      isSubmitDisabled ? '#DEDEDE 0% 0% no-repeat padding-box' : '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '5px',
    border: 'none',
    maxWidth: theme.spacing(194),
    padding: 0,
    font: 'normal normal bold 16px/18px Roboto',
    color: ({ isSubmitDisabled }: Props) => (isSubmitDisabled ? '#989898' : '#01B2AE'),
  },
  personalIdField: {
    margin: theme.spacing(15, 0, 38.5),
  },
  arrow: {
    borderColor: ({ isSubmitDisabled }: Props) => (isSubmitDisabled ? '#989898' : '#01B2AE'),
    borderWidth: '0 2px 2px 0',
    borderStyle: 'solid',
    display: 'inline-block',
    padding: theme.spacing(2),
    transform: 'rotate(-45deg)',
    marginLeft: theme.spacing(6),
  },
  errorMsg: {
    backgroundColor: 'rgba(227, 45, 45, 0.17)',
    margin: theme.spacing(-35, 0, 10),
    borderLeft: '13px solid #E32D2D',
    height: theme.spacing(35),
    display: 'flex',
    alignItems: 'center',

    '& > p': {
      font: 'normal normal normal 20px/26px Roboto',
      color: '#E32D2D',
      paddingLeft: theme.spacing(10),
    },
  },
}));
